export enum PortfolioTypeEnum {
    LegalEntity = 'LegalEntity',
    PrivateEntity = 'PrivateEntity',
}
